import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { api} from "../ui/api";

export const getTopics = createAsyncThunk("topic/fetchTopics", async (_, { rejectWithValue }) => {
    try {
        const response = await api.get("/courses/student/1/topics/");
        return response.data;
    } catch (error) {
        return rejectWithValue(error.response?.data?.detail || error.message);
    }
});
export const getNoTopics = createAsyncThunk("topic/getNoTopics", async (_, { rejectWithValue }) => {
    try {
        const response = await api.get("/courses/topic/");

        return response.data;
    } catch (error) {
        return rejectWithValue(error.response?.data?.detail || error.message);
    }
});

export const getTopicById = createAsyncThunk(
    "topic/fetchTopicById",
    async (id, { rejectWithValue }) => {
        try {
            const response = await api.get(`/courses/teacher_topics/${id}`);
            return response.data;
        } catch (error) {
            return rejectWithValue(error.message);
        }
    }
);
export const postAnswerComment = createAsyncThunk(
    "topic/fetchAnswerComment",
    async (data, { rejectWithValue }) => {
        try {
            const response = await api.post(`/courses/answers/`,data);
            return response.data;
        } catch (error) {
            return rejectWithValue(error.message);
        }
    }
);
export const postQuestionComment = createAsyncThunk(
    "topic/fetchAnswerComment",
    async (data, { rejectWithValue }) => {
        try {
            const response = await api.post(`/courses/questions/`,data);
            console.log(response)
            return response.data;
        } catch (error) {
            return rejectWithValue(error.message);
        }
    }
);
const topicSlice = createSlice({
    name: "topic",
    initialState: {
        items: [],
        topic: null,
        topicNo: [],
        loading: false,
        error: null,
    },
    extraReducers: (builder) => {
        builder
            .addCase(getTopics.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(getTopics.fulfilled, (state, action) => {
                state.loading = false;
                state.items = action.payload;
            })
            .addCase(getTopics.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload;
            })
            .addCase(getTopicById.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(getTopicById.fulfilled, (state, action) => {
                state.loading = false;
                state.topic = action.payload;
            })
            .addCase(getTopicById.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload;
            })
            .addCase(getNoTopics.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(getNoTopics.fulfilled, (state, action) => {
                state.loading = false;
                state.topicNo = action.payload;
            })
            .addCase(getNoTopics.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload;
            })
            .addCase(postAnswerComment.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(postAnswerComment.fulfilled, (state, action) => {
                state.loading = false;
            })
            .addCase(postAnswerComment.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload;
            })
    },
});

export default topicSlice.reducer;
